import React from "react";

const DNSError = () => {
  return (
    <div className="p-32 w-full">
      <p className="text-2xl">
        Seeing a blank page. Sorry for the inconvenience. The Indian Govt keeps on blocking and unblocking TMDB api according to its mood.
      </p>

      <p className="font-semibold text-2xl my-2">Quick Solution: </p>
      <ul
        className="list-disc text-xl"
      >
        <li>Connect to VPN</li>
        <li>
          Select GoogleDNS in chrome security settings. Open <span className="text-red-500">chrome://settings/security</span> <span className="italic">Scroll down to Select DNS provider and choose Google or Cloudflare or OpenDNS</span>
        </li>
      </ul>
    </div>
  );
};

export default DNSError;
